module.exports = __webpack_public_path__ + "static/media/desktop.b342903.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Clocks/desktop.mp4
// module id = q/Qy
// module chunks = 1